<template>
  <div class="strategies-dlq-table">
    <v-card-title class="toolbar primary white--text">
      <div>
        <span class="headline">
          <h1 class="headline ml-2">
            <v-icon dark>description</v-icon>
            Digital Depot DLQs
          </h1>
        </span>
      </div>
      <v-spacer />
      <v-text-field
        v-model="search"
        append-icon="search"
        label="Filter results"
        single-line
        flat
        dark
        color="primary"
        solo-inverted
        hide-details
      />
    </v-card-title>

    <!-- DATA TABLE -->
    <v-data-table
      :headers="headers"
      :items="filteredItems"
      :pagination.sync="pagination"
      :loading="isLoading"
      loading-text="Loading..."
      disable-initial-sort
    >
      <!-- SIGNINGS DATA TABLE ROW START -->
      <template
        slot="items"
        slot-scope="props"
      >
        <tr>
          <td class="">
            {{ props.item.url.split('/').pop() }}
          </td>

          <td>
            {{ props.item.ApproximateNumberOfMessages }}
          </td>

          <td class="text-xs">
            {{ props.item.ApproximateNumberOfMessagesNotVisible }}
          </td>

          <td class="text-xs">
            {{ props.item.MessageRetentionPeriod / 3600 / 24 }} days
          </td>
        </tr>
      </template>
      <!-- SIGNINGS DATA TABLE ROW END -->
    </v-data-table>
  </div>
</template>

<script>

export default {
  name: 'DigitalDepotDLQTable',
  components: {
  },
  data() {
    return {
      isLoading: false,
      isCreating: false,
      isEditing: false,
      currEditSigning: {},
      pagination: {
        rowsPerPage: '-1',
        sortBy: 'ApproximateNumberOfMessages',
        descending: true,
      },
      search: '',
      headers: [
        { text: 'Name', value: 'url' },
        { text: 'ApproximateNumberOfMessages', value: 'ApproximateNumberOfMessages' },
        { text: 'ApproximateNumberOfMessagesNotVisible Value', value: 'ApproximateNumberOfMessagesNotVisible' },
        { text: 'MessageRetentionPeriod At', value: 'MessageRetentionPeriod' },
      ],
    };
  },
  computed: {
    dlqs() {
      return this.$store.state.strategiesDLQStore.dlqs;
    },
    filteredItems() {
      const { search } = this;

      return search.length < 1 ?
        this.dlqs :
        this.dlqs.filter((item) => {
          let found = false;
          Object.keys(item)
            .map((key) => {
              if (item[key] && String(item[key]).indexOf(search) > -1) {
                found = true;
              }

              return key;
            });

          return found;
        });
    },
  },

  mounted() {
    this.getQueues();
  },

  methods: {
    getQueues() {
      this.isLoading = true;
      this.$store.dispatch('fetchStrategiesDLQs')
        .finally(() => {
          this.isLoading = false;
        });
    },
    toggleEditing() {
      this.isEditing = !this.isEditing;
    },
    onEditSigning(currEditSigning) {
      this.toggleCreating();
      this.currEditSigning = currEditSigning.data;
    },
  },
};
</script>
<style lang="scss">
  .bridge-signing-table {
    > .toolbar {
      position: relative;
      padding: 24px 24px 32px 24px;
      margin-bottom: 32px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/digitalDepots/DigitalDepotDLQTable.vue